// extracted by mini-css-extract-plugin
export default {"cabecalhoLink":"CabecalhoLink_cabecalhoLink__krtRm","link":"CabecalhoLink_link__ozlEX","textclip":"CabecalhoLink_textclip__MuCEJ","glowing":"CabecalhoLink_glowing__j9bSy"};